export default __webpack_public_path__ + "static/media/10-gm-achieved_old.6bcea264.svg";